import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'stringToList',
})
export class StringToListPipe implements PipeTransform {
  transform(value: string, jsonKey: string = undefined): string[] {
    if (!value) return [];
    try {
      if (jsonKey) {
        const matches = value.match(
          new RegExp(`'${jsonKey}': \\[([^\\]]*)\\]`),
        );
        if (matches && matches.length > 1) {
          const propertyValueString = matches[1];
          return propertyValueString
            .split("', '")
            .map((value) => value.trim().replace("'", '').replace('"', ''));
        }
        return [];
      }
      const elements = value
        .trim()
        .replace(/^\[|\]$/g, '')
        .split("', '");
      return elements.map((element) => element.replace(/(^'|'$)/g, '').trim());
    } catch (e) {
      return [];
    }
  }
}
